<template>

<com-item name="game.opponents" :size="size" :loading="loading" :is-empty="!active" :has-more="data.opponentsTotal > 5" v-on:more="onMore" title="Opponents">

	<template v-slot:about>

		<p>The people {{ you }} play this game with most often.</p>

	</template>

	<template v-slot:stats>

		<app-user type="player" :item="opponent(opp)" v-for="(opp, index) in data.opponents" :key="index" :subtext="winRate(opp)" subdate="Last played" count-text="play" :notLinked="!opp.userId" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		data: function() {

			return this.$store.getters['page/insights/game/players']

		},

		active: function() {

			return this.data && !this.loading && this.data.opponents && this.data.opponents.length

		}

	},

	methods: {

		opponent: function(opp) {

			return {
				id: opp.userId || null,
				name: opp.name,
				slug: opp.name,
				count: opp.plays,
				date: opp.lastPlayed
			}

		},

		winRate: function(opp) {

			if (!opp.plays) return ''
			return Math.round((opp.wins / opp.plays) * 100) + '% win rate'

		},

		onMore: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGamePlayers',
				id: parseInt(this.$route.params.game) || 0
			})

		}

	}

}

</script>

<style scoped>

</style>
